import { render, staticRenderFns } from "./DeliverableProjects.vue?vue&type=template&id=87e0339a&"
import script from "./DeliverableProjects.vue?vue&type=script&lang=js&"
export * from "./DeliverableProjects.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports